<div class="content">
  <form class="travel-form" [formGroup]="travelHistoryForm" (submit)="addTravel()">
    <mat-form-field>
      <mat-label>{{ 'description' | translate }}</mat-label>
      <input matInput type="text" name="description" formControlName="additional_information" />
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'start_date' | translate }}</mat-label>
      <input matInput type="text" autocomplete="off" [matDatepicker]="startpicker" formControlName="from" (focus)="startpicker.open()" />
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(travelHistoryForm.controls.from)">{{ 'this_date_is_invalid' | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field class="date-field">
      <mat-label>{{ 'end_date' | translate }}</mat-label>
      <input matInput type="text" autocomplete="off" [matDatepicker]="endpicker" formControlName="to" (focus)="endpicker.open()" />
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
      <mat-error *ngIf="checkDateValid(travelHistoryForm.controls.to)">{{ 'this_date_is_invalid' | translate }}</mat-error>
    </mat-form-field>
    <gc-location-input
      (placeAutoComplete)="populateAddress($event)"
      formControlName="location"
      [forLocation]="'anyLocation'"
    ></gc-location-input>
    <button mat-flat-button type="submit" class="add-button" [disabled]="travelHistoryForm.invalid">
      <mat-icon svgIcon="plus"></mat-icon>
      {{ 'add_travel' | translate }}
    </button>
    <div class="divider"></div>
  </form>
  <div *ngIf="historyListForm">
    <form [formGroup]="historyListForm">
      <div class="travels-display">
        <mat-accordion multi="true" formArrayName="rowList">
          <mat-expansion-panel
            class="travel-line"
            *ngFor="let travel of rowListControl.controls; let i = index"
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [formGroupName]="i"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{
                  'date_range_label'
                    | translate
                      : {
                          fromDate: (travel.get('from').value | customDate: 'dd LLLL yyyy'),
                          toDate: (travel.get('to').value | customDate: 'dd LLLL yyyy'),
                        }
                }}
              </mat-panel-title>
              <p *ngIf="(isMobile$ | async) === false">
                {{
                  'location_colon_value'
                    | translate
                      : { value: travel.get('location').value ? travel.get('location').value : ('unspecified_location' | translate) }
                }}
              </p>
            </mat-expansion-panel-header>
            <div class="panel-content">
              <mat-form-field>
                <mat-label>{{ 'description' | translate }}</mat-label>
                <input matInput type="text" name="description" formControlName="additional_information" />
              </mat-form-field>
              <mat-form-field class="date-field">
                <mat-label>{{ 'start_date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="startpicker"
                  formControlName="from"
                  (focus)="startpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
                <mat-datepicker #startpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(travel.controls.from)">{{ 'this_date_is_invalid' | translate }}</mat-error>
              </mat-form-field>
              <mat-form-field class="date-field">
                <mat-label>{{ 'end_date' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  autocomplete="off"
                  [matDatepicker]="endpicker"
                  formControlName="to"
                  (focus)="endpicker.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                <mat-datepicker #endpicker></mat-datepicker>
                <mat-error *ngIf="checkDateValid(travel.controls.to)">{{ 'this_date_is_invalid' | translate }}</mat-error>
              </mat-form-field>
              <gc-location-input
                formControlName="location"
                (placeAutoComplete)="populateAddress($event, i)"
                [incommingAddress]="rowListControl.at(i).get('location').value"
              ></gc-location-input>
            </div>
            <button class="delete-button" mat-raised-button color="warn" (click)="deleteTravel(i)">
              <mat-icon svgIcon="delete"></mat-icon>
              {{ 'delete' | translate }}
            </button>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </form>
  </div>
  <div class="button-div">
    <button
      mat-flat-button
      [ngClass]="{ primary: requestUuid === null, accent: requestUuid !== null }"
      class="save-button"
      (click)="submit()"
    >
      <mat-icon svgIcon="check"></mat-icon>
      {{ 'save_travels' | translate }}
    </button>
  </div>
</div>
